import React, { FunctionComponent } from 'react';

import { List, Record } from 'immutable';
import { IProduct } from '@server/data/models/product';
import { BlockProduct } from '@views/components/block/Block';
// import { ProductCard } from '@views/components/product/Product';
import ProductCard from '@views/modules/product-card';
import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

export type TProductListProps = {
  data: List<IProduct>;
};

export const ProductList: FunctionComponent<TProductListProps> = ({
  data = List(),
}) => (
  <BlockProduct>
    <BlockProduct.Body>
      <BlockProduct.List>
        {data.map(
          (item: Record<IProduct>): JSX.Element => (
            <BlockProduct.Item key={item.get('productId')}>
              <ProductCard
                id={item.get('productId')}
                name={item.get('name')}
                image={item.get('imageUrl')}
                listPrice={
                  item.getIn(['attributes', 'listPrice']) || item.get('price')
                }
                price={item.get('price')}
                quantityAvailable={item.get('quantity', 0)}
                hasVideo={item.get('hasVideo', false)}
                isContactProduct={item.get('isContactProduct', false)}
                isInterested={item.get('isInterested', false)}
                dataClassName={EVENT_CLASS_NAME}
                dataAction={EVENT_ACTION_NAME}
                dataCategory={EVENT_CATEGORY.PRODUCT_CATEGORY}
                dataLabel={item.get('name')}
                nofollow={!item.getIn(['attributes', 'googleIndex'])}
              />
            </BlockProduct.Item>
          )
        )}
      </BlockProduct.List>
    </BlockProduct.Body>
  </BlockProduct>
);

export default ProductList;
